import { useMutation } from '@tanstack/react-query';

import { restCall } from 'services/api/restful/client';
import { RestApiError } from 'services/api/restful/errors';
import { getTicketDownloadUrl } from 'services/api/restful/generated/tickets/tickets';

type TicketDownloadUrlMutationData = {
  ticketDownloadUrl?: { link: string };
};

export const useTicketDownloadUrl = () => {
  const { mutate, isPending, isPaused } = useMutation<
    TicketDownloadUrlMutationData,
    RestApiError,
    { ticketId: string }
  >({
    mutationFn: async ({ ticketId }) => {
      const { data } = await restCall(() => getTicketDownloadUrl(ticketId));

      return {
        ticketDownloadUrl: {
          link: data.link,
        },
      };
    },
    retry: false,
  });

  return {
    requestTicketDownloadUrl: mutate,
    isLoading: isPending && !isPaused,
  };
};
